/**
 * Authentication Provider Component
 *
 * This component initializes authentication state on app load and provides
 * a loading state while authentication is being initialized.
 */

import { useAuthInitialization } from "@/hooks/useAuthInitialization"
import type { ReactNode } from "react"

interface AuthProviderProps {
  children: ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  const { isInitializing } = useAuthInitialization()

  // Show loading spinner while initializing authentication
  if (isInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500" />
          <p className="text-gray-600">Initializing authentication...</p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
